import { StatisticsStorage } from "../storage/statistics_storage.js";

interface LockablePayload
{
  enabled: boolean;
  locked?: { reason: "level"; min_level: number };
}

export function applyLocalEventUnlock( payload: LockablePayload | null ): boolean
{
  if ( !payload || payload.enabled || payload.locked?.reason !== "level" ) return false;
  if ( StatisticsStorage.load().level < payload.locked.min_level ) return false;
  payload.enabled = true;
  return true;
}

export function isEventProgressActive( payload: LockablePayload | null, lead_levels: number ): boolean
{
  if ( !payload ) return false;
  if ( payload.enabled ) return true;
  if ( payload.locked?.reason !== "level" ) return false;
  return StatisticsStorage.load().level + lead_levels >= payload.locked.min_level;
}
